export default {
  typography: "#09044A",
  primary: {
    light: "#6C63FF",
    DEFAULT: "#2F27B4",
    "xx-dark": "#080447",
  },
  secondary: {
    "xx-light": "#E9F7F7",
    light: "#1EF9DE",
    DEFAULT: "#20B2AA",
    dark: "#166F6D",
  },
  positive: {},
  negative: {
    DEFAULT: "#FF4C61",
    dark: "#C8082D",
  },
  grayscale: {
    "xx-light": "#F4F5F9",
    "x-light": "#E3E5EE",
    light: "#A6ACBE",
    DEFAULT: "#8581AA",
    dark: "#495057",
  },
  "in-progress": {
    DEFAULT: "#FFC443",
  },
};
